export function plural(n, one, many = `${one}s`) {
  return `${n} ${n === 1 ? one : many}`;
}

export function greeting(date = new Date()) {
  const h = date.getHours();
  if (h < 5) return 'Good night';
  if (h < 12) return 'Good morning';
  if (h < 17) return 'Good afternoon';
  if (h < 22) return 'Good evening';
  return 'Good night';
}

export function percent(done, total) {
  if (!total) return 0;
  const p = (done / total) * 100;
  if (p > 0 && p < 1) return 1;
  return Math.floor(p);
}

const rtf = typeof Intl !== 'undefined' && Intl.RelativeTimeFormat ? new Intl.RelativeTimeFormat('en', { numeric: 'auto' }) : null;

export function ago(t, now = Date.now()) {
  const s = Math.round((t - now) / 1000);
  const abs = Math.abs(s);
  if (abs < 45) return 'just now';
  if (!rtf) return new Date(t).toLocaleString();
  if (abs < 3600) return rtf.format(Math.round(s / 60), 'minute');
  if (abs < 86400) return rtf.format(Math.round(s / 3600), 'hour');
  if (abs < 86400 * 30) return rtf.format(Math.round(s / 86400), 'day');
  return new Date(t).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
}

export function shortDate(t) {
  return new Date(t).toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
}

export function weekdayLetter(day) {
  return new Date(`${day}T12:00:00`).toLocaleDateString('en', { weekday: 'narrow' });
}

export function weekdayName(day) {
  return new Date(`${day}T12:00:00`).toLocaleDateString('en', { weekday: 'long' });
}

export function minutes(n) {
  return n < 1 ? 'under a minute' : `${Math.round(n)} min`;
}

// Roman numerals for part numbers.
export function roman(n) {
  return ['', 'I', 'II', 'III', 'IV', 'V'][n] || String(n);
}
